import React, { Component } from "react";
import config from "react-global-configuration";
import RequestApi from "../../Miscelania/RequestApi";

// Helpers de formulário
import Select from "react-select";
import Toggle from "react-toggle";

class CertificationsEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: "",
        type: "",
        status: "closed",
      },
      redirect_url: false,
      loaded: 0,
      certification_types: [],
      training_certification_types: [],
      signatures_select: [],
      layouts_select: [],
      id: this.props.certification_id,
      name: this.props.certification_data.name,
      company_id: this.props.certification_data.company_id,
      result: this.props.certification_data.result,
      expire: this.props.certification_data.expire,
      internal: this.props.certification_data.internal,
      hours: this.props.certification_data.hours,
      filter_function: this.props.certification_data.filter_function,
      variable_signatures: this.props.certification_data.variable_signatures,
      staff_signature: this.props.certification_data.staff_signature,
      require_grade: this.props.certification_data.require_grade,
      warning_when_expired: this.props.certification_data.warning_when_expired,
      use_data: this.props.certification_data.use_data,
      deprecated: this.props.certification_data.deprecated,
      schedule_alert: this.props.certification_data.schedule_alert,
      certification_type_id:
        this.props.certification_data.certification_type_id,
      signature_id: this.props.certification_data.signature_id,
      layout_id: this.props.certification_data.layout_id,
      bottom_right_signature_id:
        this.props.certification_data.bottom_right_signature_id,
      bottom_left_signature_id:
        this.props.certification_data.bottom_left_signature_id,
      top_left_signature_id:
        this.props.certification_data.top_left_signature_id,
      top_right_signature_id:
        this.props.certification_data.top_right_signature_id,
      training_certification_type_id:
        this.props.certification_data.training_certification_type_id,
      companies_select: this.props.companies_select,
    };

    //bind específico
    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange(name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if (event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange(name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if (
      this.state.loaded === 0 &&
      typeof newProps.certification_data.name !== "undefined" &&
      Array.isArray(newProps.training_certification_types) &&
      typeof newProps.companies_select !== "undefined" &&
      newProps.companies_select.length > 0
    ) {
      this.setState({
        id: newProps.certification_data.id,
        name: newProps.certification_data.name,
        company_id: newProps.certification_data.company_id,
        result: newProps.certification_data.result,
        expire: newProps.certification_data.expire,
        internal: newProps.certification_data.internal,
        hours: newProps.certification_data.hours,
        filter_function: newProps.certification_data.filter_function,
        layout_id: newProps.certification_data.layout_id,
        variable_signatures: newProps.certification_data.variable_signatures,
        staff_signature: newProps.certification_data.staff_signature,
        require_grade: newProps.certification_data.require_grade,
        warning_when_expired: newProps.certification_data.warning_when_expired,
        use_data: newProps.certification_data.use_data,
        deprecated: newProps.certification_data.deprecated,
        schedule_alert: newProps.certification_data.schedule_alert,
        certification_type_id:
          newProps.certification_data.certification_type_id,
        training_certification_type_id:
          newProps.certification_data.training_certification_type_id,
        signatures_select: newProps.signatures_select,
        layouts_select: newProps.layouts_select,
        certification_types: newProps.certification_types,
        bottom_right_signature_id:
          newProps.certification_data.bottom_right_signature_id,
        bottom_left_signature_id:
          newProps.certification_data.bottom_left_signature_id,
        top_left_signature_id:
          newProps.certification_data.top_left_signature_id,
        top_right_signature_id:
          newProps.certification_data.top_right_signature_id,
        training_certification_types: newProps.training_certification_types,
        companies_select: newProps.companies_select,
        loaded: 1,
      });
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    var self = this;
    this.props.handleAlert("", "", "open");
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      company_id: this.state.company_id,
      result: this.state.result,
      expire: this.state.expire,
      internal: this.state.internal,
      hours: this.state.hours,
      filter_function: this.state.filter_function,
      variable_signatures: this.state.variable_signatures,
      staff_signature: this.state.staff_signature,
      require_grade: this.state.require_grade,
      warning_when_expired: this.state.warning_when_expired,
      use_data: this.state.use_data,
      deprecated: this.state.deprecated,
      schedule_alert: this.state.schedule_alert,
      certification_type_id: this.state.certification_type_id,
      signature_id: this.state.signature_id,
      layout_id: this.state.layout_id,
      bottom_right_signature_id: this.state.bottom_right_signature_id,
      bottom_left_signature_id: this.state.bottom_left_signature_id,
      top_left_signature_id: this.state.top_left_signature_id,
      top_right_signature_id: this.state.top_right_signature_id,
      training_certification_type_id: this.state.training_certification_type_id,
    };
    var header = this.refs.request_api.header("application/json");
    Promise.resolve(header).then(function (value) {
      fetch(config.get("api") + "/certificado", {
        method: "PUT",
        mode: "cors",
        headers: value,
        body: JSON.stringify(datasave),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error(error);
        })
        .then((responseJson) => {
          self.refs.request_api.validate(responseJson, "alert");
          self.props.handleAlert(
            responseJson.message,
            responseJson.status,
            "open"
          );
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={"request_api"} />
        <form onSubmit={this.edit}>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Nome:</label>
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Registro da certificado"
                value={this.state.name}
                onChange={this.handleChange.bind(this, "name")}
                required
              />
            </div>
            {/* <div className="col-md-6 form-group">
            <label>Tipo:</label>
            <Select
              className="form-field-name"
              name="certification_type_id"
              value={this.state.certification_type_id}
              searchable={true}
              placeholder={'Selecionar modelo de aeronave'}
              onChange={this.handleSelectChange.bind(this, 'certification_type_id')}
              options={this.state.certification_types}
            />
          </div> */}
            <div className="col-md-6 form-group">
              <label>Carga horária:</label>
              <input
                type="number"
                value={this.state.hours}
                name="hours"
                className="form-control"
                onChange={this.handleChange.bind(this, "hours")}
                placeholder="Carga horária do certificado. Somente números."
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Destinado a:</label>
              <Select
                className="form-field-name"
                name="training_certification_type_id"
                value={this.state.training_certification_type_id}
                searchable={true}
                placeholder={"Selecionar tipo"}
                onChange={this.handleSelectChange.bind(
                  this,
                  "training_certification_type_id"
                )}
                options={this.state.training_certification_types}
              />
            </div>
            <div className="col-md-6 form-group">
              <label>Nota mínima:</label>
              <input
                type="number"
                name="result"
                className="form-control"
                placeholder="Nota mínima"
                value={this.state.result}
                onChange={this.handleChange.bind(this, "result")}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Validade:</label>
              <input
                type="number"
                value={this.state.expire}
                name="expire"
                className="form-control"
                onChange={this.handleChange.bind(this, "expire")}
                placeholder="Validade em meses do certificado. Somente números."
              />
            </div>
            <div className="col-md-6 form-group">
              <label>Empresa</label>
              <Select
                className="form-field-name"
                name="company_id"
                value={this.state.company_id}
                searchable={true}
                placeholder={""}
                onChange={this.handleSelectChange.bind(this, "company_id")}
                options={this.state.companies_select}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>Layout:</label>
              <Select
                className="form-field-name"
                name="layout_id"
                value={this.state.layout_id}
                searchable={true}
                placeholder={"Selecionar layout"}
                onChange={this.handleSelectChange.bind(this, "layout_id")}
                options={this.state.layouts_select}
              />
            </div>
            <div className="col-md-3 form-group">
              <label>Assinaturas Variáveis?</label>
              <br />
              <Toggle
                checked={this.state.variable_signatures}
                name="variable_signatures"
                onChange={this.handleToggleChange.bind(
                  this,
                  "variable_signatures"
                )}
              />
            </div>
            <div className="col-md-3 form-group">
              <label>Requer assinatura do aluno?</label>
              <br />
              <Toggle
                checked={this.state.staff_signature}
                name="staff_signature"
                onChange={this.handleToggleChange.bind(this, "staff_signature")}
              />
            </div>
          </div>
          <div className="row">
            {this.state.layout_id && this.state.variable_signatures == 0 ? (
              <div className="col-md-6 form-group">
                <label>Assinatura lado superior esquerdo:</label>
                <Select
                  className="form-field-name"
                  name="top_left_signature_id"
                  value={this.state.top_left_signature_id}
                  searchable={true}
                  placeholder={""}
                  onChange={this.handleSelectChange.bind(
                    this,
                    "top_left_signature_id"
                  )}
                  options={this.state.signatures_select}
                />
              </div>
            ) : (
              ""
            )}
            {this.state.layout_id && this.state.variable_signatures == 0 ? (
              <div className="col-md-6 form-group">
                <label>Assinatura lado superior direito:</label>
                <Select
                  className="form-field-name"
                  name="top_right_signature_id"
                  value={this.state.top_right_signature_id}
                  searchable={true}
                  placeholder={""}
                  onChange={this.handleSelectChange.bind(
                    this,
                    "top_right_signature_id"
                  )}
                  options={this.state.signatures_select}
                />
              </div>
            ) : (
              ""
            )}
            {this.state.layout_id && this.state.variable_signatures == 0 ? (
              <div className="col-md-6 form-group">
                <label>Assinatura lado inferior esquerdo:</label>
                <Select
                  className="form-field-name"
                  name="bottom_left_signature_id"
                  value={this.state.bottom_left_signature_id}
                  searchable={true}
                  placeholder={""}
                  onChange={this.handleSelectChange.bind(
                    this,
                    "bottom_left_signature_id"
                  )}
                  options={this.state.signatures_select}
                />
              </div>
            ) : (
              ""
            )}
            {this.state.layout_id && this.state.variable_signatures == 0 ? (
              <div className="col-md-6 form-group">
                <label>Assinatura lado inferior direito:</label>
                <Select
                  className="form-field-name"
                  name="bottom_right_signature_id"
                  value={this.state.bottom_right_signature_id}
                  searchable={true}
                  placeholder={""}
                  onChange={this.handleSelectChange.bind(
                    this,
                    "bottom_right_signature_id"
                  )}
                  options={this.state.signatures_select}
                />
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="row">
            <div className="col-md-2 form-group">
                <label>Interno</label>
                <br/>
                <Toggle
                  checked={this.state.internal}
                  name="internal"
                  onChange={this.handleToggleChange.bind(this, 'internal')} />
            </div>
            <div className="col-md-2 form-group">
                <label>Filtro por função</label>
                <br/>
                <Toggle
                  checked={this.state.filter_function}
                  name="filter_function"
                  onChange={this.handleToggleChange.bind(this, 'filter_function')} />
            </div>
            <div className="col-md-2 form-group">
                <label>Nota mínima</label>
                <br/>
                <Toggle
                  checked={this.state.require_grade}
                  name="require_grade"
                  onChange={this.handleToggleChange.bind(this, 'require_grade')} />
            </div>
            <div className="col-md-2 form-group">
                <label>Pesquisa geral</label>
                <br/>
                <Toggle
                  checked={this.state.use_data}
                  name="use_data"
                  onChange={this.handleToggleChange.bind(this, 'use_data')} />
            </div>
            <div className="col-md-2 form-group">
                <label>Defasado</label>
                <br/>
                <Toggle
                  checked={this.state.deprecated}
                  name="deprecated"
                  onChange={this.handleToggleChange.bind(this, 'deprecated')} />
            </div>
            <div className="col-md-2 form-group">
                <label>Alertar na Escala</label>
                <br/>
                <Toggle
                  checked={this.state.schedule_alert}
                  name="schedule_alert"
                  onChange={this.handleToggleChange.bind(this, 'schedule_alert')} />
            </div>
          </div>
          <hr />
          <button type="submit" className="btn btn-primary btn-lg btn-block">
            <i className="fa fa-fw fa-save"></i> Editar certificado
          </button>
        </form>
      </div>
    );
  }
}

export default CertificationsEditTab;



// WEBPACK FOOTER //
// ./src/Components/Certifications/Elements/CertificationsEditTab.js